import { Backdrop, Card, CardContent, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React, { useEffect, useState } from 'react';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import RightPane from './RightPane';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

function OrderList() {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);

  const [statistics, setStatistics] = useState({});

  return (
    <Card>
      {
        loading &&
        <Backdrop className={classes.backdrop} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
      }
      <CardContent>
        <RightPane statistics={statistics} loading={loading} setLoading={setLoading} />
      </CardContent>
    </Card>
  );
}

export default OrderList;
